/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_OfferInputs */

const cs_loading_offer = /** @type {(inputs: Loading_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítám nabídku…`)
};

const sk_loading_offer = /** @type {(inputs: Loading_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítavam ponuku…`)
};

const en_loading_offer = /** @type {(inputs: Loading_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading offer…`)
};

/**
* | output |
* | --- |
* | "Loading offer…" |
*
* @param {Loading_OfferInputs} inputs
* @param {{ locale?: "cs" | "sk" | "en" }} options
* @returns {LocalizedString}
*/
export const loading_offer = /** @type {((inputs?: Loading_OfferInputs, options?: { locale?: "cs" | "sk" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_OfferInputs, { locale?: "cs" | "sk" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "cs") return cs_loading_offer(inputs)
	if (locale === "sk") return sk_loading_offer(inputs)
	return en_loading_offer(inputs)
});